export default "__VITE_ASSET__24cd52d9__"